import { render, staticRenderFns } from "./youtubePosts.vue?vue&type=template&id=9aa652a4&scoped=true&"
import script from "./youtubePosts.vue?vue&type=script&lang=js&"
export * from "./youtubePosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa652a4",
  null
  
)

export default component.exports